module.exports = __webpack_public_path__ + "img/sms.5a86298a.svg";